export function toDiscountNumber(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function roundMoney(value) {
  const n = toDiscountNumber(value);
  return n == null ? 0 : Math.round(n);
}

export function formatRoundedRupee(value) {
  const n = toDiscountNumber(value);
  if (n == null) return "—";
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
}

/** Uses API +dealer_discounts+ rows: value, effective_value, percentage (or legacy per). */
export function getDealerDiscountSummary(itemsPrice, dealerDiscounts) {
  const rows = Array.isArray(dealerDiscounts) ? dealerDiscounts : [];
  const base = roundMoney(toDiscountNumber(itemsPrice) ?? 0);

  if (rows.length === 0) {
    return { itemsAfterDiscount: base, totalDiscount: 0, steps: [] };
  }

  const steps = rows.map((row) => {
    const from = roundMoney(toDiscountNumber(row?.value) ?? base);
    const to = roundMoney(toDiscountNumber(row?.effective_value) ?? from);
    const per = Number(row?.percentage ?? row?.per) || 0;
    return { per, from, to, amount: Math.max(0, from - to) };
  });

  const itemsAfterDiscount = steps[steps.length - 1]?.to ?? base;
  const totalDiscount = Math.max(0, base - itemsAfterDiscount);

  return { itemsAfterDiscount, totalDiscount, steps };
}
